export const DEFAULT_ROADWORK_ICON = "vks_icon_baustelle";
export const MARKER_ICON_SIZE = 48;
export const HIGHLIGHTED_MARKER_ICON_SIZE = 96;

/** Datetime format used for dayjs formatting. */
export const dayjsFormat = "DD.MM.YYYY HH:mm:ss";

/** intervalls for refreshing data first number is the minute
 * and it then gets calculated to ms*/
export const ROADWORK_INTERVAL = 1 * 60 * 1000;
